/**
 * OPCO field of the company form: the "Autre" text input shows, and is enabled, only while
 * "Autre" is selected. The merge screen renders the field once per side, so each select finds
 * its own text input through `data-funding-body-other-for`.
 */
export function mountFundingBodySelect(select, wrapper, win = window) {
  const otherChoice = select.getAttribute("data-funding-body-other-choice");

  function sync() {
    if (!select.isConnected || !wrapper.isConnected) return;
    const isOther = select.value === otherChoice;
    wrapper.style.display = isOther ? "" : "none";
    const input = wrapper.querySelector("input, textarea");
    // On the merge screen the side not kept is disabled as a whole; its text stays disabled.
    if (input) input.disabled = !isOther || select.disabled === true;
  }

  select.addEventListener("change", sync);
  win.addEventListener("pageshow", () => {
    // History navigation can restore form values after pageshow without a change event.
    setTimeout(sync, 0);
  });
  sync();
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[data-funding-body-select="true"]').forEach((select) => {
    const wrapper = document.querySelector(`[data-funding-body-other-for="${select.id}"]`);
    if (wrapper) mountFundingBodySelect(select, wrapper);
  });
});
